<template>
  <div class="field field-buttons">
    <div class="buttons has-addons">
      <button class="button" @click="$emit('addTweet')" :title="`${$modifierKeyEncoded}-Enter: Insert a new blank tweet below this one.`">
        <b-icon icon="arrow-down" size="is-small" class="is-hidden-mobile" type="success"></b-icon>
        <span class="has-text-weight-semibold">Add</span>
      </button>

      <button class="button" @click="$emit('breakTweet')"
              :title="`${$modifierKeyEncoded}-I: Insert a new tweet, moving any characters after the carat into it.`">
        <b-icon icon="level-down-alt" size="is-small" class="is-hidden-mobile" type="info"></b-icon>
        <span>Break</span>
      </button>

      <button class="button" :disabled="isBottom" @click="$emit('flowDown')"
              :title="`${$modifierKeyEncoded}-F: Flow text after carat into start of tweet below.`">
        <b-icon icon="wave-square" size="is-small" class="is-hidden-mobile" type="info"></b-icon>
        <span>Flow<span class="is-hidden-mobile">  down</span></span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "EditorButtons",

  props: {
    isTop: {
      type: Boolean,
      default: false
    },
    isBottom: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>

</style>
